import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'mg-at-root',
  templateUrl: './at-root.component.html',
  styleUrls: ['./at-root.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AtRootComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
